"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/material/styles");

const UqTheme = (0, _styles.createTheme)({
  palette: {
    primary: {
      main: '#004558',
      light: '#10576A',
      dark: '#033443'
    },
    secondary: {
      main: '#43A047',
      light: '#76D275',
      dark: '#00563F'
    },
    error: {
      main: '#EA4274',
      light: '#FF97B6',
      dark: '#AC234C'
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)'
    }
  },
  typography: {
    h4: {
      fontSize: '2rem'
    },
    button: {
      textTransform: 'none',
      fontWeight: 500
    }
  },
  wrappers: {
    uqButton: {
      sx: {
        borderRadius: '100px',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      }
    }
  }
});
var _default = UqTheme;
exports.default = _default;